// extracted by mini-css-extract-plugin
module.exports = {"btn":"PlaceOrderButton_btn__1yTH_","sell":"PlaceOrderButton_sell__2S-vf","hold":"PlaceOrderButton_hold__Qvtf1","buy":"PlaceOrderButton_buy__E_aIZ"};